
import {interval as observableInterval,  Observable } from 'rxjs';

import {takeWhile} from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FileValidationService } from '@app/services/shared/file-validation.service';
import { DnaService } from '@app/services/shared/dna.service';
import { DocumentGeneratorService } from '@app/services/automation/documentgenerator.service';
import { DocumentGeneratorAnalysis } from '@app/models/automation/documentgenerator/documentgeneratoranalysis.model';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DocumentGeneratorAnalysisFile } from '@app/models/automation/documentgenerator/documentgeneratoranalysisfile.model';
import { BasicDataGenerationResult } from "@app/models/phoenix/phoenix.basic-data-generation-result.model";
import { HttpParams } from "@angular/common/http";


import { saveAs } from "file-saver";
import { BasicData } from "@app/models/phoenix/phoenix.basic-data.model";
import { AutomationUtilService } from "@app/services/automation/automation-util.service";
import { AutomationFunctionCodes } from "@app/models/functioninfo/automationfunctioncodes.model";
import { PhoenixService } from "@app/services/phoenix/phoenix.service";
import { ModalService } from "@app/services/shared/modal.service";
import { CustomFileUploadComponent } from "@app/shared/components/customfileupload/customfileupload.component";
import { DocumentGeneratorAnalysisWrapper } from '@app/models/automation/documentgenerator/documentgeneratoranalysiswrapper.model';
import { FileService } from "@app/services/filemanagement/file.service";
import { DocumentGeneratorProcessRequest } from "@app/models/automation/documentgenerator/documentGeneratorProcessRequest";
import { Discipline } from "@app/models/shared/discipline.enum";
import { DocumentGeneratorProcessRequestWrapper } from "@app/models/automation/documentgenerator/documentGeneratorProcessRequestWrapper.model";
import { PhoenixRequestDetails } from "@app/models/phoenix/phoenix.request-details.model";
import { EnumDiscipline } from "@app/models/dna/dna.discipline.enum";
import { DisciplineService } from "@app/services/shared/discipline.service";
import { SettingsService } from "@app/services/shared/settings.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-documentgeneratoranalyis',
  templateUrl: './documentgeneratoranalysis.component.html',
  styleUrls: ['./documentgeneratoranalysis.component.scss']
})
export class DocumentGeneratorAnalysisComponent implements OnInit, OnDestroy {

  @ViewChild(CustomFileUploadComponent, { static: true })
  public uploadComponent: CustomFileUploadComponent;

  public selectedFiles: string[];
  public isButtonSetDisabled: boolean;
  public documentGeneratorAnalysisWrappers: DocumentGeneratorAnalysisWrapper[];

  public previewDocumentUrl: string;
  public documentDownloadUrl: string;
  private subFolderName: string = '';
  public addReference: boolean;

  public processedFileForBar: number;
  public totalFileForBar: number;

  private basicDataSubscriptionCanRun: boolean;

  public defaultDna: { clientName: string, dnaName: string, dnaId: number };

  private dgwProcessSubscription;

  constructor(private toasterService: ToastrService,
    public settings: SettingsService,
    private fileValidationService: FileValidationService,
    private dnaService: DnaService,
    private documentGeneratorService: DocumentGeneratorService,
    private ngxSmartModalService: NgxSmartModalService,
    private phoenixService: PhoenixService,
    private modalService: ModalService,
    private fileService: FileService,
    private _disciplineService: DisciplineService,
    private automationUtilService: AutomationUtilService) {
  }

  public ngOnInit() {
    this.basicDataSubscriptionCanRun = true;
    this.addReference = false;
    this.dnaService.defaultDnaObservable.subscribe(
      (res) => {
        if (!res || !res.dnaId || res.dnaId <= 0) {
          this.settings.layout.offsidebarOpen = true;
          return;
        }
        else {
          this.settings.layout.offsidebarOpen = false;
          this.defaultDna = res;
        }
      },
      error => { console.log(error) });

    this.subFolderName = Date.now().toString();
    this.uploadComponent.subfolderName = this.subFolderName + '\\';
  }

  public ngOnDestroy(): void {
    this.basicDataSubscriptionCanRun = false;
    this.fileService.deleteSubfolderUnderUserFolder(this.subFolderName).subscribe();
  }


  public uploadedFileChanged(eventArgs) {
    this.selectedFiles = eventArgs;
  }

  public analyzeFile() {
    if (!this.fileValidationService.validateFiles(this.selectedFiles)) {
      return;
    }

    this.isButtonSetDisabled = true;
    this.totalFileForBar = 100;
    this.processedFileForBar = 0;

    let extensions = this.getSelectedFileExtensions();
    if (!extensions) {
      this.toasterService.warning('Please upload a file.');
      return;
    }

    this.toasterService.info('Template file is being processed. This might take a while.', 'Process');
    if (extensions.indexOf('.dwg') >= 0) {
      this.analyzeDwgFile();
    } else if (extensions.indexOf('.pdf') >= 0) {
      this.analyze();
    } else if (extensions.indexOf('.xlsx') >= 0) {
      this.analyze();
    }
  }

  private analyzeDwgFile() {
    let dwgFiles = this.selectedFiles.filter(p => p.endsWith('.dwg'));

    let basicDataObject: BasicData = {
      programName: this.automationUtilService.getProgramNameFromFunction(AutomationFunctionCodes.DocumentGenerator),
      discipline: parseInt(EnumDiscipline.All.toString()),
      fileList: dwgFiles,
      dnaId: this.defaultDna.dnaId,
      functionCode: AutomationFunctionCodes.DocumentGenerator
    };

    this.phoenixService.createBasicData(basicDataObject).subscribe(
      (result: BasicDataGenerationResult) => {
        let basicDataResult = result; //remove basic data and try like that
        this.basicDataSubscriptionCanRun = true;

        let paramsForRequestDetails: PhoenixRequestDetails = new PhoenixRequestDetails();
        paramsForRequestDetails.basicData = basicDataObject;
        paramsForRequestDetails.sequenceList = basicDataResult.sequenceList;
        paramsForRequestDetails.overridenDisciplines = this._disciplineService.getDisciplineNameFromId(parseInt(EnumDiscipline.All.toString()));
        paramsForRequestDetails.functionCode = AutomationFunctionCodes.DocumentGenerator;
        this.phoenixService.createPhoenixRequestDetails(paramsForRequestDetails).subscribe();

        const params = new HttpParams()
          .set('sequenceList', basicDataResult.sequenceList.join(','))
          .set('functionCode', AutomationFunctionCodes.DocumentGenerator);

        this.dgwProcessSubscription = observableInterval(3000).pipe(
          takeWhile(() => {
            return dwgFiles.length > 0 && this.basicDataSubscriptionCanRun;
          }))
          .subscribe(i => {
            this.phoenixService.checkFileProcessState(params).subscribe(
              (res) => {
                this.processedFileForBar = res.processedFiles;
                if (dwgFiles.length * 100 === res.processedFiles) {
                  this.basicDataSubscriptionCanRun = false;
                  if (this.dgwProcessSubscription) {
                    this.dgwProcessSubscription.unsubscribe();
                  }
                  this.analyze();
                }
              },
              () => {
                this.basicDataSubscriptionCanRun = false;
              }
            );
          });
      },
      () => {
        this.toasterService.error('Files can\'t get processed. Please try again later.');
      }
    );
  }

  public cleanTheFormForNextRequest() {
    this.selectedFiles = [];
    this.isButtonSetDisabled = false;
    this.basicDataSubscriptionCanRun = true;
    this.processedFileForBar = 0;
    this.totalFileForBar = 0;
    this.uploadComponent.clearFiles();
    this.addReference = false;
  }

  private getSelectedFileExtensions() {
    if (!this.selectedFiles) {
      return null;
    }
    let extensions: string[] = [];
    this.selectedFiles.forEach(selectedFile => {
      let lastIndex = selectedFile.lastIndexOf('.');
      extensions.push(selectedFile.substr(lastIndex, selectedFile.length - lastIndex));
    });
    return extensions;
  }

  private analyze() {
    this.documentGeneratorService.analyze(this.defaultDna.dnaId, this.selectedFiles).subscribe(result => {
      this.documentGeneratorAnalysisWrappers = result;
      this.documentGeneratorAnalysisWrappers.forEach(wrapper => {
        wrapper.totalQuantityIdentified = 0;
        wrapper.totalSelectedFilesCount = 0;
        wrapper.documentGeneratorAnalysisList.forEach(item => {
          item.filesSelected = 0;
          wrapper.totalQuantityIdentified += item.quantityIdentified;
          if (item.firstFile) {
            item.firstFile.isSelected = true;
            if (item.secondFile) {
              item.secondFile.isSelected = true;
              if (item.thirdFile) {
                item.thirdFile.isSelected = true;
              }
            }
          }
          this.calculateSelectedFileCount(item);
        });
      });
      this.isButtonSetDisabled = false;
      this.toasterService.success('Process is completed successfully.');
    },
      error => {
        this.modalService.showModal(
          "Operation can't be completed. Please try again later",
          "Error Occured");
        this.isButtonSetDisabled = false;
        throw error;
      });
  }

  private calculateSelectedFileCount(documentGeneratorAnalysis: DocumentGeneratorAnalysis) {
    let count = 0;
    if (documentGeneratorAnalysis.firstFile && documentGeneratorAnalysis.firstFile.isSelected) {
      count++;
    }
    if (documentGeneratorAnalysis.secondFile && documentGeneratorAnalysis.secondFile.isSelected) {
      count++;
    }
    if (documentGeneratorAnalysis.thirdFile && documentGeneratorAnalysis.thirdFile.isSelected) {
      count++;
    }
    documentGeneratorAnalysis.filesSelected = count;
    this.documentGeneratorAnalysisWrappers.forEach(wrapper => {
      wrapper.totalSelectedFilesCount = 0;
      wrapper.documentGeneratorAnalysisList.forEach(item => {
        wrapper.totalSelectedFilesCount += item.filesSelected;
      });
    });
  }

  public checkAll(wrapper: DocumentGeneratorAnalysisWrapper, fileName, $event) {
    if (!$event.currentTarget.checked) {
      return;
    }
    wrapper.documentGeneratorAnalysisList.forEach(documentGeneratorAnalysis => {
      if (fileName == 'firstFile' && documentGeneratorAnalysis.firstFile) {
        if (documentGeneratorAnalysis.firstFile) {
          documentGeneratorAnalysis.firstFile.isSelected = $event.currentTarget.checked;
        }
      } else if (fileName == 'secondFile' && documentGeneratorAnalysis.secondFile) {
        if (documentGeneratorAnalysis.secondFile) {
          documentGeneratorAnalysis.secondFile.isSelected = $event.currentTarget.checked;
        }
      } else if (fileName == 'thirdFile' && documentGeneratorAnalysis.thirdFile) {
        if (documentGeneratorAnalysis.thirdFile) {
          documentGeneratorAnalysis.thirdFile.isSelected = $event.currentTarget.checked;
        }
      }
      this.calculateSelectedFileCount(documentGeneratorAnalysis);
    });
  }

  public previewFile(file: DocumentGeneratorAnalysisFile) {
    this.documentGeneratorService.createDocumentPreview(file.id).subscribe(result => {
      this.documentDownloadUrl = result.result;
      this.previewDocumentUrl = 'https://docs.google.com/gview?url=' + window.location.origin + '/' + result.result + '&embedded=true';
      this.ngxSmartModalService.getModal('previewModal').open();
    });
  }

  public process() {
    let request = this.createProcessRequest();
    if (!request) {
      this.toasterService.warning('There is no file added for device');
      return;
    }

    this.doRequest(request);
  }

  private doRequest(wrapper: DocumentGeneratorProcessRequestWrapper) {
    this.documentGeneratorService.process(wrapper).subscribe(res => {
      if (res.body != null && res.body.status != null) {
        if (res.body.status === 'processing') return;

        if (res.body.status === 'fileServed') {
          this.toasterService.success('Compressed file generated and queued for uploading.');

          return;
        }
      }

      if (res.content && res.content.size > 0) {
        saveAs(res.content, res.fileName);
        this.toasterService.success('Compressed file generated and downloaded.');
      }
    });
  }

  public processDiscipline(wrapper: DocumentGeneratorAnalysisWrapper) {
    let request = this.createProcessRequest(wrapper);

    if (!request) {
      this.toasterService.warning('There is no file added for device');
      return;
    }

    this.doRequest(request);
  }

  private createProcessRequest(wrapper: DocumentGeneratorAnalysisWrapper = null) {
    let requestWrapper = new DocumentGeneratorProcessRequestWrapper();
    requestWrapper.dnaClientId = this.defaultDna.dnaId;
    requestWrapper.files = this.selectedFiles;
    requestWrapper.functionCode = AutomationFunctionCodes.DocumentGenerator;
    requestWrapper.documentGeneratorProcessRequests = [];

    let content: DocumentGeneratorAnalysisWrapper[];

    if (wrapper) {
      content = [wrapper];
      requestWrapper.selectedDiscipline = <Discipline>wrapper.disciplineName;
    } else {
      content = this.documentGeneratorAnalysisWrappers;
    }

    if(!content || content.length<=0){
      return null;
    }
    content.forEach(item => {
      let documentGeneratorIds: number[] = [];

      if (!item.documentGeneratorAnalysisList || item.documentGeneratorAnalysisList.length <= 0) {
        return;
      }
      item.documentGeneratorAnalysisList.forEach(documentGeneratorAnalysis => {
        if (documentGeneratorAnalysis.firstFile && documentGeneratorAnalysis.firstFile.isSelected) {
          documentGeneratorIds.push(documentGeneratorAnalysis.firstFile.id);
        }
        if (documentGeneratorAnalysis.secondFile && documentGeneratorAnalysis.secondFile.isSelected) {
          documentGeneratorIds.push(documentGeneratorAnalysis.secondFile.id);
        }
        if (documentGeneratorAnalysis.thirdFile && documentGeneratorAnalysis.thirdFile.isSelected) {
          documentGeneratorIds.push(documentGeneratorAnalysis.thirdFile.id);
        }
      });

      let request = new DocumentGeneratorProcessRequest();
      request.documentGeneratorIds = documentGeneratorIds;
      request.devices = [];
      request.selectedDiscipline = <Discipline>item.disciplineName;
      item.documentGeneratorAnalysisList.forEach(item => {
        request.devices.push({ deviceName: item.deviceName, quantity: item.quantityIdentified });
      });
      requestWrapper.documentGeneratorProcessRequests.push(request);
    });

    if (requestWrapper.documentGeneratorProcessRequests.length <= 0) {
      return null;
    }
    return requestWrapper;
  }

  public cleanForm() {
    this.selectedFiles = new Array<string>();
    this.uploadComponent.clearFiles();
    this.documentGeneratorAnalysisWrappers = [];
    this.cleanTheFormForNextRequest();
  }

  private completeRequest() {
    this.cleanTheFormForNextRequest();
    this.toasterService.success('Compressed file generated and queued for uploading.');
  }
}
